import React, { createContext, useContext, useState, useEffect } from "react";
import { ProfileInput } from "./index";

interface ProfileContextType {
  profile: ProfileInput;
  setProfile: (profile: ProfileInput) => void;
  resetProfile: () => void;
}

const DEFAULT_PROFILE: ProfileInput = {
  fullName: "",
  profileUrl: "",
  headline: "",
  about: "",
  skills: "",
  industry: "",
  position: "",
  experiences: [],
  servicesBio: "",
  servicesList: "",
};

const ProfileContext = createContext<ProfileContextType | undefined>(undefined);

export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) throw new Error("useProfile must be used within a ProfileProvider");
  return context;
};

export const ProfileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [profile, setProfileState] = useState<ProfileInput>(() => {
    const saved = localStorage.getItem("profile_data");
    return saved ? JSON.parse(saved) : DEFAULT_PROFILE;
  });

  const setProfile = (data: ProfileInput) => {
    setProfileState(data);
    localStorage.setItem("profile_data", JSON.stringify(data));
  };

  const resetProfile = () => {
    setProfileState(DEFAULT_PROFILE);
    localStorage.removeItem("profile_data");
  };

  return (
    <ProfileContext.Provider value={{ profile, setProfile, resetProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};
